<p-accordion [activeIndex]="openAccordion ? 0 : -1">
  <p-accordionTab
    headerStyleClass="bg-primary text-white"
    iconPos="end">
    <ng-template pTemplate="header">
      <span class="flex align-items-center gap-2 w-full">
        <img
          src="assets/common/icons/description.svg"
          alt="logo-contrat" />
        <span>{{ "contract.title" | translate }}</span>
      </span>
    </ng-template>
    <div *ngIf="contracts.length > 0">
      <div
        class="cursor-pointer bg-lightest rounded p-3 mb-1 font-app-light min-h-full min-w-full hover:border-primary border-transparent border-[1px] flex flex-col gap-2"
        *ngFor="let contract of contracts"
        (click)="navigateToDetails(contract.id)"
        (keydown)="onKeyDown($event, contract.id)">
        <div class="flex justify-between">
          @if (isBranch(contract, branches.MRH)) {
            <app-address-mrh
              [bgLogo]="'bg-primary'"
              [colorLogo]="'text-white'"
              [data]="contract"></app-address-mrh>
          } @else if (isBranch(contract, branches.PJ)) {
            <app-title-pj
              [bgLogo]="'bg-primary'"
              [colorLogo]="'text-white'"></app-title-pj>
          } @else if (isBranch(contract, branches.SA)) {
            <app-title-sa
              [bgLogo]="'bg-primary'"
              [colorLogo]="'white'"
              [animalName]="contract.animalName"></app-title-sa>
          }
          <app-status-card
            [status]="contract.status"
            [statusConfig]="policyStatusConfig"
            [date]="contract.effectiveStartDate"
            class="justify-end"></app-status-card>
        </div>
        <app-contract-card [contract]="contract" />
      </div>
    </div>
  </p-accordionTab>
</p-accordion>
